import { httpCreate } from './http';
import { createNamespacedHelpers } from 'vuex';

const http = httpCreate('/srv/conditional-lottery-participation');

export const conditionalLotteryParticipation = {
	//获取兑奖名单/未兑奖名单
	getWinLists(lotteryId, params) {
		return http.get(`/${lotteryId}/winList`, { params });
	},
	//标记已兑奖/未兑奖
	awardOperation(id, params) {
		return http.put(`/${id}/changeExpiryStatus`, {}, params);
	},
	//批量标记为已兑奖
	batchWinning(ids) {
		return http.put('/changeExpiryStatus', ids);
	},
	// 中奖名单
	winnerlistOflottery(lotteryId, params) {
		return http.get(`/${lotteryId}/lotteryWinList`, { params });
	},
	latestWinList(lotteryId) {
		return http.get(`/${lotteryId}/latestWinList`);
	},
};
